import {createAsyncThunk} from "@reduxjs/toolkit";
import {firestore} from "../../config/firebaseConfig";

export const createVendor = createAsyncThunk(
    'vendor/create',
    async ({data, onResolve}) => {
        try {
            await firestore.collection('vendors').add(data);
            onResolve && onResolve('done')
        } catch (e) {
            // console.log(e)
            onResolve && onResolve('failed')
        }

    }
)

export const updateVendor = createAsyncThunk(
    'vendor/update',
    async ({data, onResolve}) => {
        try {
            await firestore.collection('vendors').doc(data.id).update(data);
            onResolve && onResolve('done')
        } catch (e) {
            // console.log(e)
            onResolve && onResolve('failed')
        }

    }
)